import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import { makeStyles } from "@material-ui/core/styles";
import api from "assets/services/api";

const styles = {
    btnFindClient: {
        backgroundColor: "#4169e1",
        marginTop: "25%",
        '&:hover': {
            backgroundColor: '#303f9f',
        },
    },
    sizeAddContact: {
        color: "#4169e1",
        overflow: "visible"
    },
    buttonIcon: {
        fontSize: "50px",
        padding: "0"
    },

};

const useStyles = makeStyles(styles);
function ModalUpdateZone(props) {

    const classStyles = useStyles();
    const { storageId, storageUserType } = useAuth();

    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);

    const [code, setCode] = useState(props.props.code);
    const [name, setName] = useState(props.props.name);


    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.getZones();
                        props.onHide();
                    }, 3000);
                }
                break;
            default:
                break;
        }
    };
    const handleAddRegion = async (e) => {
        e.preventDefault();
        const addRegion = await api.patch(`/zone/${storageId}/${props.props.id}`, {
            name,
            type: storageUserType
        });
        if (addRegion.status === 200) {
            setControlSnack(true);
        } else if (addRegion.status === 209) {
            alert(`Nome em uso`);
        } else {
            alert(`Contatar suporte`)
        }
    };
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Zona
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddRegion}>
                <Modal.Body >
                    <Form.Row>
                        <Form.Group as={Col} xs={3} controlId="formGridName">
                            <Form.Label>CODIGO</Form.Label>
                            <Form.Control
                                value={code}
                                className="form-control"
                                placeholder="Codigo"
                                type="text"
                                onChange={(event) => {
                                    setCode(event.target.value)
                                }}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={9} controlId="formGridName">
                            <Form.Label>NOME</Form.Label>
                            <Form.Control
                                value={name}
                                className="form-control"
                                placeholder="Nome"
                                type="text"
                                onChange={(event) => {
                                    setName(event.target.value)
                                }}
                                autoComplete='off'
                            />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Salvar
                        </Button>
                    </div>
                    <Snackbar
                        place="br"
                        color="success"
                        icon={AddAlert}
                        message="Cliente adicionado com sucesso"
                        open={br}
                        closeNotification={() => setBR(false)}
                        close
                    />
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalUpdateZone;